"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserSupportServiceServer = exports.UserSupportServiceDispatcher = exports.UserSupportServiceClient = void 0;
var AttachmentUpload_1 = require("./AttachmentUpload");
var ReportedIssue_1 = require("./ReportedIssue");
var services_shared_1 = require("@playq/services-shared");
var SupportRequest_1 = require("./SupportRequest");
var UserSupportRequests_1 = require("./UserSupportRequests");
var SupportRequestId_1 = require("./SupportRequestId");
var AttachmentId_1 = require("./AttachmentId");
var MultipartUploadStatus_1 = require("./MultipartUploadStatus");
var Hash_1 = require("./Hash");
var AttachmentType_1 = require("./AttachmentType");
var AttachmentWithName_1 = require("./AttachmentWithName");
var IssueCreateData_1 = require("./IssueCreateData");
var SupportRequestCreateData_1 = require("./SupportRequestCreateData");
var AttachmentData_1 = require("./AttachmentData");
var irt_1 = require("@playq/irt");
var InUploadAttachment = (function () {
    function InUploadAttachment(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.name = data.name;
        this.attachmentType = AttachmentType_1.AttachmentType[data.attachmentType];
    }
    Object.defineProperty(InUploadAttachment.prototype, "name", {
        get: function () {
            return this._name;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field name is not optional');
            }
            if (typeof value !== 'string') {
                throw new Error('Field name expects type string, got ' + value);
            }
            this._name = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InUploadAttachment.prototype, "attachmentType", {
        get: function () {
            return this._attachmentType;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field attachmentType is not optional');
            }
            this._attachmentType = value;
        },
        enumerable: false,
        configurable: true
    });
    InUploadAttachment.prototype.serialize = function () {
        return {
            name: this.name,
            attachmentType: AttachmentType_1.AttachmentType[this.attachmentType]
        };
    };
    return InUploadAttachment;
}());
var OutUploadAttachmentHelpers = (function () {
    function OutUploadAttachmentHelpers() {
    }
    OutUploadAttachmentHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutUploadAttachmentHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new AttachmentUpload_1.AttachmentUpload(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutUploadAttachmentHelpers;
}());
var InUploadAttachmentBatch = (function () {
    function InUploadAttachmentBatch(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.attachments = data.attachments.map(function (e) { return new AttachmentWithName_1.AttachmentWithName(e); });
    }
    Object.defineProperty(InUploadAttachmentBatch.prototype, "attachments", {
        get: function () {
            return this._attachments;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field attachments is not optional');
            }
            this._attachments = value;
        },
        enumerable: false,
        configurable: true
    });
    InUploadAttachmentBatch.prototype.serialize = function () {
        return {
            attachments: this.attachments.map(function (e) { return e.serialize(); })
        };
    };
    return InUploadAttachmentBatch;
}());
var OutUploadAttachmentBatchHelpers = (function () {
    function OutUploadAttachmentBatchHelpers() {
    }
    OutUploadAttachmentBatchHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.map(function (e) { return e.serialize(); })
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutUploadAttachmentBatchHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(content.map(function (e) { return new AttachmentUpload_1.AttachmentUpload(e); }));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutUploadAttachmentBatchHelpers;
}());
var InUploadAttachmentBase64 = (function () {
    function InUploadAttachmentBase64(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.name = data.name;
        this.attachmentType = AttachmentType_1.AttachmentType[data.attachmentType];
        this.content = data.content;
        this.uploadHash = new Hash_1.Hash(data.uploadHash);
    }
    Object.defineProperty(InUploadAttachmentBase64.prototype, "name", {
        get: function () {
            return this._name;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field name is not optional');
            }
            if (typeof value !== 'string') {
                throw new Error('Field name expects type string, got ' + value);
            }
            this._name = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InUploadAttachmentBase64.prototype, "attachmentType", {
        get: function () {
            return this._attachmentType;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field attachmentType is not optional');
            }
            this._attachmentType = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InUploadAttachmentBase64.prototype, "content", {
        get: function () {
            return this._content;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field content is not optional');
            }
            if (typeof value !== 'string') {
                throw new Error('Field content expects type string, got ' + value);
            }
            this._content = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InUploadAttachmentBase64.prototype, "uploadHash", {
        get: function () {
            return this._uploadHash;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field uploadHash is not optional');
            }
            this._uploadHash = value;
        },
        enumerable: false,
        configurable: true
    });
    InUploadAttachmentBase64.prototype.serialize = function () {
        return {
            name: this.name,
            attachmentType: AttachmentType_1.AttachmentType[this.attachmentType],
            content: this.content,
            uploadHash: this.uploadHash.serialize()
        };
    };
    return InUploadAttachmentBase64;
}());
var OutUploadAttachmentBase64Helpers = (function () {
    function OutUploadAttachmentBase64Helpers() {
    }
    OutUploadAttachmentBase64Helpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutUploadAttachmentBase64Helpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new AttachmentData_1.AttachmentData(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutUploadAttachmentBase64Helpers;
}());
var InInitiateMultipartUpload = (function () {
    function InInitiateMultipartUpload(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.name = data.name;
        this.attachmentType = AttachmentType_1.AttachmentType[data.attachmentType];
        this.totalChunks = data.totalChunks;
    }
    Object.defineProperty(InInitiateMultipartUpload.prototype, "name", {
        get: function () {
            return this._name;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field name is not optional');
            }
            if (typeof value !== 'string') {
                throw new Error('Field name expects type string, got ' + value);
            }
            this._name = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InInitiateMultipartUpload.prototype, "attachmentType", {
        get: function () {
            return this._attachmentType;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field attachmentType is not optional');
            }
            this._attachmentType = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InInitiateMultipartUpload.prototype, "totalChunks", {
        get: function () {
            return this._totalChunks;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field totalChunks is not optional');
            }
            if (typeof value !== 'number') {
                throw new Error('Field totalChunks expects type number, got ' + value);
            }
            if (value % 1 !== 0) {
                throw new Error('Field totalChunks is expected to be an integer, got ' + value);
            }
            this._totalChunks = value;
        },
        enumerable: false,
        configurable: true
    });
    InInitiateMultipartUpload.prototype.serialize = function () {
        return {
            name: this.name,
            attachmentType: AttachmentType_1.AttachmentType[this.attachmentType],
            totalChunks: this.totalChunks
        };
    };
    return InInitiateMultipartUpload;
}());
var OutInitiateMultipartUploadHelpers = (function () {
    function OutInitiateMultipartUploadHelpers() {
    }
    OutInitiateMultipartUploadHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutInitiateMultipartUploadHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new AttachmentData_1.AttachmentData(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutInitiateMultipartUploadHelpers;
}());
var InCancelMultipartUpload = (function () {
    function InCancelMultipartUpload(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.id = new AttachmentId_1.AttachmentId(data.id);
    }
    Object.defineProperty(InCancelMultipartUpload.prototype, "id", {
        get: function () {
            return this._id;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field id is not optional');
            }
            this._id = value;
        },
        enumerable: false,
        configurable: true
    });
    InCancelMultipartUpload.prototype.serialize = function () {
        return {
            id: this.id.serialize()
        };
    };
    return InCancelMultipartUpload;
}());
var OutCancelMultipartUploadHelpers = (function () {
    function OutCancelMultipartUploadHelpers() {
    }
    OutCancelMultipartUploadHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutCancelMultipartUploadHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new services_shared_1.CommonSuccess(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutCancelMultipartUploadHelpers;
}());
var InFinishMultipartUpload = (function () {
    function InFinishMultipartUpload(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.id = new AttachmentId_1.AttachmentId(data.id);
        this.uploadHash = new Hash_1.Hash(data.uploadHash);
    }
    Object.defineProperty(InFinishMultipartUpload.prototype, "id", {
        get: function () {
            return this._id;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field id is not optional');
            }
            this._id = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InFinishMultipartUpload.prototype, "uploadHash", {
        get: function () {
            return this._uploadHash;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field uploadHash is not optional');
            }
            this._uploadHash = value;
        },
        enumerable: false,
        configurable: true
    });
    InFinishMultipartUpload.prototype.serialize = function () {
        return {
            id: this.id.serialize(),
            uploadHash: this.uploadHash.serialize()
        };
    };
    return InFinishMultipartUpload;
}());
var OutFinishMultipartUploadHelpers = (function () {
    function OutFinishMultipartUploadHelpers() {
    }
    OutFinishMultipartUploadHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutFinishMultipartUploadHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new services_shared_1.CommonSuccess(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutFinishMultipartUploadHelpers;
}());
var InMultipartUploadStatus = (function () {
    function InMultipartUploadStatus(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.id = new AttachmentId_1.AttachmentId(data.id);
    }
    Object.defineProperty(InMultipartUploadStatus.prototype, "id", {
        get: function () {
            return this._id;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field id is not optional');
            }
            this._id = value;
        },
        enumerable: false,
        configurable: true
    });
    InMultipartUploadStatus.prototype.serialize = function () {
        return {
            id: this.id.serialize()
        };
    };
    return InMultipartUploadStatus;
}());
var OutMultipartUploadStatusHelpers = (function () {
    function OutMultipartUploadStatusHelpers() {
    }
    OutMultipartUploadStatusHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutMultipartUploadStatusHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new MultipartUploadStatus_1.MultipartUploadStatus(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutMultipartUploadStatusHelpers;
}());
var InUploadChunk = (function () {
    function InUploadChunk(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.id = new AttachmentId_1.AttachmentId(data.id);
        this.chunkNumber = data.chunkNumber;
        this.base64 = data.base64;
        this.hash = new Hash_1.Hash(data.hash);
    }
    Object.defineProperty(InUploadChunk.prototype, "id", {
        get: function () {
            return this._id;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field id is not optional');
            }
            this._id = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InUploadChunk.prototype, "chunkNumber", {
        get: function () {
            return this._chunkNumber;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field chunkNumber is not optional');
            }
            if (typeof value !== 'number') {
                throw new Error('Field chunkNumber expects type number, got ' + value);
            }
            if (value % 1 !== 0) {
                throw new Error('Field chunkNumber is expected to be an integer, got ' + value);
            }
            this._chunkNumber = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InUploadChunk.prototype, "base64", {
        get: function () {
            return this._base64;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field base64 is not optional');
            }
            if (typeof value !== 'string') {
                throw new Error('Field base64 expects type string, got ' + value);
            }
            this._base64 = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InUploadChunk.prototype, "hash", {
        get: function () {
            return this._hash;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field hash is not optional');
            }
            this._hash = value;
        },
        enumerable: false,
        configurable: true
    });
    InUploadChunk.prototype.serialize = function () {
        return {
            id: this.id.serialize(),
            chunkNumber: this.chunkNumber,
            base64: this.base64,
            hash: this.hash.serialize()
        };
    };
    return InUploadChunk;
}());
var OutUploadChunkHelpers = (function () {
    function OutUploadChunkHelpers() {
    }
    OutUploadChunkHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutUploadChunkHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new services_shared_1.CommonSuccess(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutUploadChunkHelpers;
}());
var InSendSupportRequest = (function () {
    function InSendSupportRequest(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.data = new SupportRequestCreateData_1.SupportRequestCreateData(data.data);
    }
    Object.defineProperty(InSendSupportRequest.prototype, "data", {
        get: function () {
            return this._data;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field data is not optional');
            }
            this._data = value;
        },
        enumerable: false,
        configurable: true
    });
    InSendSupportRequest.prototype.serialize = function () {
        return {
            data: this.data.serialize()
        };
    };
    return InSendSupportRequest;
}());
var OutSendSupportRequestHelpers = (function () {
    function OutSendSupportRequestHelpers() {
    }
    OutSendSupportRequestHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutSendSupportRequestHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new SupportRequestId_1.SupportRequestId(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutSendSupportRequestHelpers;
}());
var InRequestStatus = (function () {
    function InRequestStatus(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.id = new SupportRequestId_1.SupportRequestId(data.id);
    }
    Object.defineProperty(InRequestStatus.prototype, "id", {
        get: function () {
            return this._id;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field id is not optional');
            }
            this._id = value;
        },
        enumerable: false,
        configurable: true
    });
    InRequestStatus.prototype.serialize = function () {
        return {
            id: this.id.serialize()
        };
    };
    return InRequestStatus;
}());
var OutRequestStatusHelpers = (function () {
    function OutRequestStatusHelpers() {
    }
    OutRequestStatusHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutRequestStatusHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new SupportRequest_1.SupportRequest(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutRequestStatusHelpers;
}());
var InGetRequests = (function () {
    function InGetRequests(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.iterator = new services_shared_1.TimeOffsetIterator(data.iterator);
    }
    Object.defineProperty(InGetRequests.prototype, "iterator", {
        get: function () {
            return this._iterator;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field iterator is not optional');
            }
            this._iterator = value;
        },
        enumerable: false,
        configurable: true
    });
    InGetRequests.prototype.serialize = function () {
        return {
            iterator: this.iterator.serialize()
        };
    };
    return InGetRequests;
}());
var OutGetRequestsHelpers = (function () {
    function OutGetRequestsHelpers() {
    }
    OutGetRequestsHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutGetRequestsHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new UserSupportRequests_1.UserSupportRequests(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutGetRequestsHelpers;
}());
var InReportIssue = (function () {
    function InReportIssue(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.issue = new IssueCreateData_1.IssueCreateData(data.issue);
    }
    Object.defineProperty(InReportIssue.prototype, "issue", {
        get: function () {
            return this._issue;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field issue is not optional');
            }
            this._issue = value;
        },
        enumerable: false,
        configurable: true
    });
    InReportIssue.prototype.serialize = function () {
        return {
            issue: this.issue.serialize()
        };
    };
    return InReportIssue;
}());
var OutReportIssueHelpers = (function () {
    function OutReportIssueHelpers() {
    }
    OutReportIssueHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutReportIssueHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new ReportedIssue_1.ReportedIssue(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutReportIssueHelpers;
}());
var UserSupportServiceClient = (function () {
    function UserSupportServiceClient(transport) {
        this._transport = transport;
    }
    UserSupportServiceClient.prototype.getPackageName = function () { return UserSupportServiceClient.PackageName; };
    UserSupportServiceClient.prototype.getClassName = function () { return UserSupportServiceClient.ClassName; };
    UserSupportServiceClient.prototype.getFullClassName = function () { return UserSupportServiceClient.FullClassName; };
    UserSupportServiceClient.prototype.send = function (method, data, inputType, outputType) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this._transport.send(UserSupportServiceClient.ClassName, method, data)
                .then(function (data) {
                try {
                    var output = new outputType(data);
                    resolve(output);
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    UserSupportServiceClient.prototype.uploadAttachment = function (name, attachmentType) {
        var _this = this;
        var __data = new InUploadAttachment();
        __data.name = name;
        __data.attachmentType = attachmentType;
        return new Promise(function (resolve, reject) {
            _this._transport.send(UserSupportServiceClient.ClassName, 'uploadAttachment', __data)
                .then(function (data) {
                try {
                    resolve(OutUploadAttachmentHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    UserSupportServiceClient.prototype.uploadAttachmentBatch = function (attachments) {
        var _this = this;
        var __data = new InUploadAttachmentBatch();
        __data.attachments = attachments;
        return new Promise(function (resolve, reject) {
            _this._transport.send(UserSupportServiceClient.ClassName, 'uploadAttachmentBatch', __data)
                .then(function (data) {
                try {
                    resolve(OutUploadAttachmentBatchHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    UserSupportServiceClient.prototype.uploadAttachmentBase64 = function (name, attachmentType, content, uploadHash) {
        var _this = this;
        var __data = new InUploadAttachmentBase64();
        __data.name = name;
        __data.attachmentType = attachmentType;
        __data.content = content;
        __data.uploadHash = uploadHash;
        return new Promise(function (resolve, reject) {
            _this._transport.send(UserSupportServiceClient.ClassName, 'uploadAttachmentBase64', __data)
                .then(function (data) {
                try {
                    resolve(OutUploadAttachmentBase64Helpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    UserSupportServiceClient.prototype.initiateMultipartUpload = function (name, attachmentType, totalChunks) {
        var _this = this;
        var __data = new InInitiateMultipartUpload();
        __data.name = name;
        __data.attachmentType = attachmentType;
        __data.totalChunks = totalChunks;
        return new Promise(function (resolve, reject) {
            _this._transport.send(UserSupportServiceClient.ClassName, 'initiateMultipartUpload', __data)
                .then(function (data) {
                try {
                    resolve(OutInitiateMultipartUploadHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    UserSupportServiceClient.prototype.cancelMultipartUpload = function (id) {
        var _this = this;
        var __data = new InCancelMultipartUpload();
        __data.id = id;
        return new Promise(function (resolve, reject) {
            _this._transport.send(UserSupportServiceClient.ClassName, 'cancelMultipartUpload', __data)
                .then(function (data) {
                try {
                    resolve(OutCancelMultipartUploadHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    UserSupportServiceClient.prototype.finishMultipartUpload = function (id, uploadHash) {
        var _this = this;
        var __data = new InFinishMultipartUpload();
        __data.id = id;
        __data.uploadHash = uploadHash;
        return new Promise(function (resolve, reject) {
            _this._transport.send(UserSupportServiceClient.ClassName, 'finishMultipartUpload', __data)
                .then(function (data) {
                try {
                    resolve(OutFinishMultipartUploadHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    UserSupportServiceClient.prototype.multipartUploadStatus = function (id) {
        var _this = this;
        var __data = new InMultipartUploadStatus();
        __data.id = id;
        return new Promise(function (resolve, reject) {
            _this._transport.send(UserSupportServiceClient.ClassName, 'multipartUploadStatus', __data)
                .then(function (data) {
                try {
                    resolve(OutMultipartUploadStatusHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    UserSupportServiceClient.prototype.uploadChunk = function (id, chunkNumber, base64, hash) {
        var _this = this;
        var __data = new InUploadChunk();
        __data.id = id;
        __data.chunkNumber = chunkNumber;
        __data.base64 = base64;
        __data.hash = hash;
        return new Promise(function (resolve, reject) {
            _this._transport.send(UserSupportServiceClient.ClassName, 'uploadChunk', __data)
                .then(function (data) {
                try {
                    resolve(OutUploadChunkHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    UserSupportServiceClient.prototype.sendSupportRequest = function (data) {
        var _this = this;
        var __data = new InSendSupportRequest();
        __data.data = data;
        return new Promise(function (resolve, reject) {
            _this._transport.send(UserSupportServiceClient.ClassName, 'sendSupportRequest', __data)
                .then(function (data) {
                try {
                    resolve(OutSendSupportRequestHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    UserSupportServiceClient.prototype.requestStatus = function (id) {
        var _this = this;
        var __data = new InRequestStatus();
        __data.id = id;
        return new Promise(function (resolve, reject) {
            _this._transport.send(UserSupportServiceClient.ClassName, 'requestStatus', __data)
                .then(function (data) {
                try {
                    resolve(OutRequestStatusHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    UserSupportServiceClient.prototype.getRequests = function (iterator) {
        var _this = this;
        var __data = new InGetRequests();
        __data.iterator = iterator;
        return new Promise(function (resolve, reject) {
            _this._transport.send(UserSupportServiceClient.ClassName, 'getRequests', __data)
                .then(function (data) {
                try {
                    resolve(OutGetRequestsHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    UserSupportServiceClient.prototype.reportIssue = function (issue) {
        var _this = this;
        var __data = new InReportIssue();
        __data.issue = issue;
        return new Promise(function (resolve, reject) {
            _this._transport.send(UserSupportServiceClient.ClassName, 'reportIssue', __data)
                .then(function (data) {
                try {
                    resolve(OutReportIssueHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    UserSupportServiceClient.PackageName = 'net.playq.services.beetle';
    UserSupportServiceClient.ClassName = 'UserSupportService';
    UserSupportServiceClient.FullClassName = 'net.playq.services.beetle.UserSupportService';
    return UserSupportServiceClient;
}());
exports.UserSupportServiceClient = UserSupportServiceClient;
var UserSupportServiceDispatcher = (function () {
    function UserSupportServiceDispatcher(marshaller, server) {
        this.marshaller = marshaller;
        this.server = server;
    }
    UserSupportServiceDispatcher.prototype.getSupportedService = function () {
        return 'UserSupportService';
    };
    UserSupportServiceDispatcher.prototype.getSupportedMethods = function () {
        return UserSupportServiceDispatcher.methods;
    };
    UserSupportServiceDispatcher.prototype.dispatch = function (context, method, data) {
        var _this = this;
        switch (method) {
            case "uploadAttachment": {
                var obj_1 = new InUploadAttachment(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.uploadAttachment(context, obj_1.name, obj_1.attachmentType)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutUploadAttachmentHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "uploadAttachmentBatch": {
                var obj_2 = new InUploadAttachmentBatch(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.uploadAttachmentBatch(context, obj_2.attachments)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutUploadAttachmentBatchHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "uploadAttachmentBase64": {
                var obj_3 = new InUploadAttachmentBase64(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.uploadAttachmentBase64(context, obj_3.name, obj_3.attachmentType, obj_3.content, obj_3.uploadHash)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutUploadAttachmentBase64Helpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "initiateMultipartUpload": {
                var obj_4 = new InInitiateMultipartUpload(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.initiateMultipartUpload(context, obj_4.name, obj_4.attachmentType, obj_4.totalChunks)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutInitiateMultipartUploadHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "cancelMultipartUpload": {
                var obj_5 = new InCancelMultipartUpload(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.cancelMultipartUpload(context, obj_5.id)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutCancelMultipartUploadHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "finishMultipartUpload": {
                var obj_6 = new InFinishMultipartUpload(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.finishMultipartUpload(context, obj_6.id, obj_6.uploadHash)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutFinishMultipartUploadHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "multipartUploadStatus": {
                var obj_7 = new InMultipartUploadStatus(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.multipartUploadStatus(context, obj_7.id)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutMultipartUploadStatusHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "uploadChunk": {
                var obj_8 = new InUploadChunk(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.uploadChunk(context, obj_8.id, obj_8.chunkNumber, obj_8.base64, obj_8.hash)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutUploadChunkHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "sendSupportRequest": {
                var obj_9 = new InSendSupportRequest(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.sendSupportRequest(context, obj_9.data)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutSendSupportRequestHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "requestStatus": {
                var obj_10 = new InRequestStatus(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.requestStatus(context, obj_10.id)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutRequestStatusHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "getRequests": {
                var obj_11 = new InGetRequests(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.getRequests(context, obj_11.iterator)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutGetRequestsHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "reportIssue": {
                var obj_12 = new InReportIssue(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.reportIssue(context, obj_12.issue)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutReportIssueHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            default:
                throw new Error("Method ".concat(method, " is not supported by UserSupportServiceDispatcher."));
        }
    };
    UserSupportServiceDispatcher.methods = [
        "uploadAttachment",
        "uploadAttachmentBatch",
        "uploadAttachmentBase64",
        "initiateMultipartUpload",
        "cancelMultipartUpload",
        "finishMultipartUpload",
        "multipartUploadStatus",
        "uploadChunk",
        "sendSupportRequest",
        "requestStatus",
        "getRequests",
        "reportIssue"
    ];
    return UserSupportServiceDispatcher;
}());
exports.UserSupportServiceDispatcher = UserSupportServiceDispatcher;
var UserSupportServiceServer = (function (_super) {
    __extends(UserSupportServiceServer, _super);
    function UserSupportServiceServer(marshaller) {
        var _this = _super.call(this, marshaller, null) || this;
        _this.server = _this;
        return _this;
    }
    UserSupportServiceServer.prototype.uploadAttachment = function (context, name, attachmentType) {
        throw new Error('Not implemented.');
    };
    UserSupportServiceServer.prototype.uploadAttachmentBatch = function (context, attachments) {
        throw new Error('Not implemented.');
    };
    UserSupportServiceServer.prototype.uploadAttachmentBase64 = function (context, name, attachmentType, content, uploadHash) {
        throw new Error('Not implemented.');
    };
    UserSupportServiceServer.prototype.initiateMultipartUpload = function (context, name, attachmentType, totalChunks) {
        throw new Error('Not implemented.');
    };
    UserSupportServiceServer.prototype.cancelMultipartUpload = function (context, id) {
        throw new Error('Not implemented.');
    };
    UserSupportServiceServer.prototype.finishMultipartUpload = function (context, id, uploadHash) {
        throw new Error('Not implemented.');
    };
    UserSupportServiceServer.prototype.multipartUploadStatus = function (context, id) {
        throw new Error('Not implemented.');
    };
    UserSupportServiceServer.prototype.uploadChunk = function (context, id, chunkNumber, base64, hash) {
        throw new Error('Not implemented.');
    };
    UserSupportServiceServer.prototype.sendSupportRequest = function (context, data) {
        throw new Error('Not implemented.');
    };
    UserSupportServiceServer.prototype.requestStatus = function (context, id) {
        throw new Error('Not implemented.');
    };
    UserSupportServiceServer.prototype.getRequests = function (context, iterator) {
        throw new Error('Not implemented.');
    };
    UserSupportServiceServer.prototype.reportIssue = function (context, issue) {
        throw new Error('Not implemented.');
    };
    return UserSupportServiceServer;
}(UserSupportServiceDispatcher));
exports.UserSupportServiceServer = UserSupportServiceServer;
//# sourceMappingURL=UserSupportService.js.map